module.exports = __webpack_public_path__ + "img/download-icon.2a583c7c.svg";